/** @jsx jsx */
import { useState } from 'react';
import { jsx } from 'theme-ui';
import styled from '@emotion/styled';
import theme from '../../gatsby-plugin-theme-ui-v1';

const Container = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  height: 20px;
  margin-right: 1em;
  min-width: 20px;
  padding: 0;
`;

const Bars = styled.div`
  background-color: ${theme.colors.gray60};
  position: relative;
  height: 2px;
  transition: 0.1s ease-in-out;
  width: 100%;

  &:before,
  &:after {
    background-color: ${theme.colors.gray60};
    content: '';
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    transform-origin: center;
    transition: 0.1s ease-in-out;
    width: 100%;
  }
  &:before {
    top: -6px;
  }
  &:after {
    bottom: -6px;
  }
  &.open {
    transform: rotate(45deg);
    &:before {
      top: 0;
      transform: rotate(-90deg);
    }
    &:after {
      display: none;
    }
  }
`;

const BurgerMenuButton = ({ onClick, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Container
      className={className}
      onClick={() => {
        setIsOpen(!isOpen);
        onClick();
      }}
    >
      <Bars className={isOpen ? 'open' : 'closed'} />
    </Container>
  );
};

export default BurgerMenuButton;
